const Style = {

  stat: 'relative text-center min-h-max',
  icon: 'absolute top-1/2 left-4 -translate-y-1/2',
  value: 'text-[2.5rem] font-bold',
  change: 'absolute top-1/2 right-5 text-sm text-center -translate-y-1/2',
  changeIcon: 'absolute top-[0.1em] -right-5',
  label: 'text-sm text-slate-400 mb-3',

}

export default Style;